export let RelationshipStatus;

(function (RelationshipStatus) {
  RelationshipStatus["Pending"] = "pending";
  RelationshipStatus["Approved"] = "approved";
  RelationshipStatus["Canceled"] = "canceled";
  RelationshipStatus["Terminated"] = "terminated";
})(RelationshipStatus || (RelationshipStatus = {}));

export let RelationshipProgressStatus;

(function (RelationshipProgressStatus) {
  RelationshipProgressStatus["Sent"] = "sent";
  RelationshipProgressStatus["Reviewed"] = "reviewed";
  RelationshipProgressStatus["MicroDeposit"] = "microDeposit";
  RelationshipProgressStatus["PaymentMethod"] = "paymentMethod";
  RelationshipProgressStatus["Approved"] = "approved";
  RelationshipProgressStatus["MicroDepositFailed"] = "microDepositFailed";
})(RelationshipProgressStatus || (RelationshipProgressStatus = {}));